var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SectionTitle',[_c('h5',[_vm._v("Cursos em progresso")])]),_c('UserProfileCoursesIndex',{attrs:{"user":_vm.user},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var courses = ref.courses;
var isLoading = ref.isLoading;
return [_c('UserProfileCoursesList',{attrs:{"courses":courses}}),(courses.length >= 5)?_c('div',{staticClass:"text-center pt-4 pb-4",on:{"click":_vm.showUserCourses}},[_c('SecondaryButton',[_vm._v("ver todos os cursos")])],1):_vm._e()]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }